"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _rsManagement = require("@/api/rsManagement");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'VerifyOrderDialog',
  data: function data() {
    return {
      visible: false,
      searchLoading: false,
      confirmLoading: false,
      formData: {
        orderNo: '',
        pickupCode: ''
      },
      orderInfo: null
    };
  },
  methods: {
    open: function open(row) {
      this.visible = true;
      this.formData.orderNo = row.orderNo || '';
      // this.formData.pickupCode = row.pickupCode || ''
      this.orderInfo = null;

      // 如果有核销码，自动查询
      if (this.formData.pickupCode) {
        this.handleSearch();
      }
    },
    handleClose: function handleClose() {
      this.visible = false;
      this.formData = {
        orderNo: '',
        pickupCode: ''
      };
      this.orderInfo = null;
    },
    // 查询核销订单信息
    handleSearch: function () {
      var _handleSearch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (this.formData.pickupCode) {
                _context.n = 1;
                break;
              }
              this.$message.warning('请输入核销码');
              return _context.a(2);
            case 1:
              if (this.formData.orderNo) {
                _context.n = 2;
                break;
              }
              this.$message.warning('订单编号不能为空');
              return _context.a(2);
            case 2:
              this.searchLoading = true;
              _context.p = 3;
              _context.n = 4;
              return (0, _rsManagement.getWriteOffOrder)({
                orderNo: this.formData.orderNo,
                pickupCode: this.formData.pickupCode
              });
            case 4:
              res = _context.v;
              if (res) {
                this.orderInfo = res;
                this.$message.success('查询成功');
              } else {
                this.orderInfo = null;
                this.$message.warning('未找到订单信息');
              }
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              console.error('查询核销订单失败：', _t);
              // this.$message.error('查询失败：' + (error.message || '未知错误'))
              this.orderInfo = null;
            case 6:
              _context.p = 6;
              this.searchLoading = false;
              return _context.f(6);
            case 7:
              return _context.a(2);
          }
        }, _callee, this, [[3, 5, 6, 7]]);
      }));
      function handleSearch() {
        return _handleSearch.apply(this, arguments);
      }
      return handleSearch;
    }(),
    // 确认核销
    handleConfirm: function () {
      var _handleConfirm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this = this;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (this.orderInfo) {
                _context3.n = 1;
                break;
              }
              this.$message.warning('请先查询订单信息');
              return _context3.a(2);
            case 1:
              this.$confirm('确认核销该订单吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                var _t2;
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.p = _context2.n) {
                    case 0:
                      _this.confirmLoading = true;
                      _context2.p = 1;
                      _context2.n = 2;
                      return (0, _rsManagement.doWriteOffOrder)({
                        orderNo: _this.formData.orderNo,
                        pickupCode: _this.formData.pickupCode
                      });
                    case 2:
                      _this.$message.success('核销成功');
                      _this.$emit('success');
                      _this.handleClose();
                      _context2.n = 4;
                      break;
                    case 3:
                      _context2.p = 3;
                      _t2 = _context2.v;
                      console.error('核销失败：', _t2);
                      // this.$message.error('核销失败：' + (error.message || '未知错误'))
                    case 4:
                      _context2.p = 4;
                      _this.confirmLoading = false;
                      return _context2.f(4);
                    case 5:
                      return _context2.a(2);
                  }
                }, _callee2, null, [[1, 3, 4, 5]]);
              }))).catch(function () {
                // 用户取消
              });
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function handleConfirm() {
        return _handleConfirm.apply(this, arguments);
      }
      return handleConfirm;
    }()
  }
};